import { FILTER_FIELD_TYPES } from '../../ui/data/filters/filterTypes';

export const TEST_CYCLE_FILTER_DEFAULTS = {
  status: 'All',
  owner: [],
  purpose: 'All',
  type: 'All',
  platforms: [],
  subPlatforms: [],
  browsers: [],
  geographies: [],
  languages: [],
  cloudDevice: [],
};
export function buildTestCycleFilterConfig() {
  return [
    {
      key: 'status',
      label: 'Status',
      type: FILTER_FIELD_TYPES.SELECT,
      defaultValue: 'All',
      gridSize: 6,
    },
    {
      key: 'owner',
      label: 'Owner',
      type: FILTER_FIELD_TYPES.MULTI_SELECT,
      defaultValue: [],
      gridSize: 6,
      placeholder: 'Select owners',
    },
    {
      key: 'purpose',
      label: 'Purpose',
      type: FILTER_FIELD_TYPES.SELECT,
      defaultValue: 'All',
      gridSize: 6,
    },
    {
      key: 'type',
      label: 'Test Cycle Type',
      type: FILTER_FIELD_TYPES.SELECT,
      defaultValue: 'All',
      gridSize: 6,
    },
    {
      key: 'platforms',
      label: 'Platforms',
      type: FILTER_FIELD_TYPES.MULTI_SELECT,
      defaultValue: [],
      gridSize: 4,
      placeholder: 'Select platforms',
      // hide from FilterModal filter fields — shown via ExecutionScopeForm
      hiddenField: true,
    },
    {
      key: 'subPlatforms',
      label: 'Sub Platforms',
      type: FILTER_FIELD_TYPES.MULTI_SELECT,
      defaultValue: [],
      gridSize: 4,
      hiddenField: true,
    },
    {
      key: 'browsers',
      label: 'Browsers',
      type: FILTER_FIELD_TYPES.MULTI_SELECT,
      defaultValue: [],
      gridSize: 4,
      hiddenField: true,
    },
    {
      key: 'geographies',
      label: 'Geographies',
      type: FILTER_FIELD_TYPES.MULTI_SELECT,
      defaultValue: [],
      gridSize: 4,
      hiddenField: true,
    },
    {
      key: 'languages',
      label: 'Languages',
      type: FILTER_FIELD_TYPES.MULTI_SELECT,
      defaultValue: [],
      gridSize: 4,
      hiddenField: true,
    },
    {
      key: 'cloudDevice',
      label: 'Cloud Device Labs',
      type: FILTER_FIELD_TYPES.MULTI_SELECT,
      defaultValue: [],
      gridSize: 4,
      hiddenField: true,
    },
  ];
}
